
import { Observable } from 'rxjs';
import { UserDetailsStatus } from '@coin-depo-types';

export interface VerificationFacade {
  cachedIdentityVerification$: Observable<boolean>;
  cachedTOTPEnabledVerification$: Observable<boolean>;
  cachedSumsubKYC$: Observable<boolean>;
  cachedIsSumsubKYCRequired$: Observable<boolean>;
  cachedTUserDetailsStatus$: Observable<UserDetailsStatus | null>;
  cachedFullVerification$: Observable<boolean>;

  identityVerificationSnapshot(): boolean;
  sumsubKYCSnapshot(): boolean;
  TOTPEnabledVerificationSnapshot(): boolean;
  userDetailsStatusSnapshot(): UserDetailsStatus | null;
  setIdentityVerification(enable: boolean): void;
  setTOTPEnabledVerification(enable: boolean): void;
  setSumsubKYC(enable: boolean): void;
  setIsSumsubKYCRequired(enable: boolean): void;
  setSumsubPOA(enable: boolean): void;
  setIsSumsubPOARequired(enable: boolean): void;
  setUserDetailsStatus(status: UserDetailsStatus | null): void;
}
